import { n as a } from "./property-9daa16cd.mjs";
import { i as l, b as c, E as m, x as p, d as u } from "./createReactComponent-58f9bea8.mjs";
import { e as g } from "./class-map-2994e95e.mjs";
var v = Object.defineProperty, b = Object.getOwnPropertyDescriptor, d = (o, i, e, t) => {
  for (var n, r = t > 1 ? void 0 : t ? b(i, e) : i, h = o.length - 1; h >= 0; h--)
    (n = o[h]) && (r = (t ? n(i, e, r) : n(r)) || r);
  return t && r && v(i, e, r), r;
}, x = ((o) => (o.RIGHT = "right", o.LEFT = "left", o))(x || {});
class s extends m {
  constructor() {
    super(...arguments), this.minWidth = 272, this.maxWidth = 752, this.disabled = !1, this.position = "right", this.resizeParent = !1, this.startX = 0, this.startWidth = 0, this.onMouseDown = (i) => {
      if (this.disabled)
        return;
      this.toggleRezizeHandler(!0), this.startX = this.position === "right" ? i.clientX + 24 : i.clientX - 24;
      const e = this.getTargetElement();
      e && (this.startWidth = e.offsetWidth, document.addEventListener("mousemove", this.onMouseMove), document.addEventListener("mouseup", this.onMouseUp));
    }, this.onMouseMove = (i) => {
      const e = i.clientX - this.startX;
      let t = this.startWidth;
      this.position === "left" ? t -= e : t += e, t = Math.max(this.minWidth, t), t = Math.min(this.maxWidth, t);
      const n = this.getTargetElement();
      n && (n.style.width = `${t}px`);
    }, this.onMouseUp = () => {
      document.removeEventListener("mousemove", this.onMouseMove), document.removeEventListener("mouseup", this.onMouseUp), this.dispatchCustomEvent("onResizeComplete", {}), this.toggleRezizeHandler(!1);
    }, this.handleKeyDown = (i) => {
      const e = this.getTargetElement();
      if (!e || this.disabled)
        return;
      let t = e.offsetWidth;
      switch (i.key) {
        case "ArrowRight":
          t += this.position === "right" ? 30 : -30;
          break;
        case "ArrowLeft":
          t += this.position === "right" ? -30 : 30;
          break;
        case "Home":
          t = this.position === "right" ? this.minWidth : this.maxWidth;
          break;
        case "End":
          t = this.position === "right" ? this.maxWidth : this.minWidth;
          break;
        default:
          return;
      }
      t = Math.max(this.minWidth, t), t = Math.min(this.maxWidth, t), e.style.width = `${t}px`, this.dispatchCustomEvent("onResizeComplete", {});
    };
  }
  getTargetElement() {
    return this.resizeParent ? this.parentElement : document.getElementById(this.targetId);
  }
  toggleRezizeHandler(i) {
    const e = this.querySelector(".resize-container");
    e && (i ? e.classList.add("active") : e.classList.remove("active"));
  }
  render() {
    return p`
      <div
        class=${g({ "resize-container": !0, disabled: this.disabled })}
      >
        <div
          tabindex="0"
          aria-disabled=${this.disabled.toString()}
          class="divider"
          @mousedown="${this.onMouseDown}"
          @keydown="${this.handleKeyDown}"
        ></div>
      </div>
    `;
  }
}
s.styles = l`
    ${c(`:host .resize-container{display:flex;height:100%;box-sizing:border-box}:host .resize-container:hover .divider,:host .resize-container:active .divider,:host .resize-container.active .divider{background:var(--exo-color-background-selected)}:host .resize-container .divider{display:flex;width:var(--exo-spacing-3x-small);height:100%;flex-direction:column;justify-content:center;align-items:center;cursor:col-resize;flex-shrink:0}:host .resize-container.disabled .divider{pointer-events:none;background:var(--exo-color-background-disabled)}:host .divider:focus-visible{background:var(--exo-color-background-selected);outline:none}
`)}
  `, d([a({ type: Number })], s.prototype, "minWidth", 2), d([a({ type: Number })], s.prototype, "maxWidth", 2), d([a({ type: Boolean, reflect: !0 })], s.prototype, "disabled", 2), d([a({ type: String })], s.prototype, "targetId", 2), d([a({ type: String })], s.prototype, "position", 2), d([a({ type: Boolean, attribute: "resize-parent" })], s.prototype, "resizeParent", 2);
const W = u("ex-resize-handle", s);
export {
  x as R,
  s as a,
  W as r
};
